import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56b95dbc")

_pushScopeId("data-v-56b95dbc")
const _hoisted_1 = { class: "userUpload" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "当事人身份证明", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "当事人身份证明", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_10 = { class: "userUploadType" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "营业执照副本", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_13 = { class: "userUploadType" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "法定代表人身份证明", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_16 = { class: "userUploadType" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "委托函", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "userUploadType"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "其它", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "当事人身份证明", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_26 = { class: "userUploadType" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "代理人身份证明", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_30 = { class: "userUploadType" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "授权委托书", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_33 = { class: "userUploadType" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "tit" }, "其他", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_36 = { class: "btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SelectIdentityType = _resolveComponent("SelectIdentityType")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      ($props.userType === 1 && $props.proxyType === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", null, [
              _hoisted_3,
              _createVNode(_component_SelectIdentityType, { onChangeIdentityType: $setup.changeIdentityType }, null, 8, ["onChangeIdentityType"]),
              _createVNode(_component_el_upload, {
                data: { type: 20, courtId: $setup.courtId },
                "list-type": "picture-card",
                limit: $setup.identityType > 1 ? 3 : 1,
                "on-success": $setup.userHandleSuccess,
                accept: $setup.acceptImageUrl,
                "file-list": $setup.urlsList.caseUser,
                "before-upload": (file) => $setup.beforeUpload(file, 'userHandleSuccess'),
                class: {hide:$setup.isHide($setup.urlsList.caseUser, $setup.identityType > 1 ? 3 : 1)} ,
                "on-remove": $setup.userHandleRemove,
                multiple: ""
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["data", "limit", "on-success", "accept", "file-list", "before-upload", "class", "on-remove"]),
              ($setup.identityType === 1)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    data: { type: 20, courtId: $setup.courtId },
                    "list-type": "picture-card",
                    limit: 1,
                    "on-success": $setup.userBackHandleSuccess,
                    "file-list": $setup.urlsList.identityPhotoBackUrl,
                    class: { hide: $setup.isHide($setup.urlsList.identityPhotoBackUrl, 1) },
                    "on-preview": $setup.handlePictureCardPreview,
                    "before-upload": (file) => $setup.beforeUpload(file, 'userBackHandleSuccess'),
                    accept: $setup.acceptImageUrl,
                    "on-remove": $setup.userBackHandleRemove,
                    style: {"margin-top":"10px"},
                    action: $setup.getUrl + '/file/uploadConfirmAddressFile',
                    multiple: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["data", "on-success", "file-list", "class", "on-preview", "before-upload", "accept", "on-remove", "action"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    ($props.userType === 1 && $props.proxyType === 2)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", null, [
            _hoisted_7,
            _createVNode(_component_SelectIdentityType, { onChangeIdentityType: $setup.changeIdentityType }, null, 8, ["onChangeIdentityType"]),
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "list-type": "picture-card",
              limit: $setup.identityType > 1 ? 3 : 1,
              "on-success": $setup.legalIdentityHandleSuccess,
              "on-preview": $setup.handlePictureCardPreview,
              "file-list": $setup.urlsList.legalIdentity,
              class: {
            hide: $setup.isHide($setup.urlsList.legalIdentity, $setup.identityType > 1 ? 3 : 1)
          },
              "before-upload": (file) => $setup.beforeUpload(file, 'legalIdentityHandleSuccess'),
              "on-remove": $setup.legalIdentityHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["data", "limit", "on-success", "on-preview", "file-list", "class", "before-upload", "on-remove", "accept", "action"]),
            ($setup.identityType === 1)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  style: {"margin-top":"10px"},
                  data: { type: 20, courtId: $setup.courtId },
                  "list-type": "picture-card",
                  limit: 1,
                  "on-success": $setup.userBackHandleSuccess,
                  "before-upload": (file) => $setup.beforeUpload(file, 'userBackHandleSuccess'),
                  "file-list": $setup.urlsList.identityPhotoBackUrl,
                  class: { hide: $setup.isHide($setup.urlsList.identityPhotoBackUrl, 1) },
                  "on-preview": $setup.handlePictureCardPreview,
                  "on-remove": $setup.userBackHandleRemove,
                  accept: $setup.acceptImageUrl,
                  action: $setup.getUrl + '/file/uploadConfirmAddressFile',
                  multiple: ""
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["data", "on-success", "before-upload", "file-list", "class", "on-preview", "on-remove", "accept", "action"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "file-list": $setup.urlsList.legalWorkIdentity,
              "on-preview": $setup.handlePictureCardPreview,
              "on-success": $setup.legalWorkIdentityHandleSuccess,
              "list-type": "picture-card",
              limit: 3,
              class: { hide: $setup.isHide($setup.urlsList.legalWorkIdentity, 3) },
              "before-upload": (file) => $setup.beforeUpload(file, 'legalWorkIdentityHandleSuccess'),
              "on-remove": $setup.legalWorkIdentityHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["data", "file-list", "on-preview", "on-success", "class", "before-upload", "on-remove", "accept", "action"])
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "on-preview": $setup.handlePictureCardPreview,
              "list-type": "picture-card",
              limit: 3,
              "on-success": $setup.hirePaperworkUrlHandleSuccess,
              class: { hide: $setup.isHide($setup.urlsList.hirePaperworkUrl, 3) },
              "before-upload": (file) => $setup.beforeUpload(file, 'hirePaperworkUrlHandleSuccess'),
              "on-remove": $setup.hirePaperworkUrlHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile'
            }, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["data", "on-preview", "on-success", "class", "before-upload", "on-remove", "accept", "action"])
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "file-list": $setup.urlsList.delegationUrl,
              "on-preview": $setup.handlePictureCardPreview,
              "list-type": "picture-card",
              limit: 3,
              "on-success": $setup.delegationUrlHandleSuccess,
              class: { hide: $setup.isHide($setup.urlsList.delegationUrl, 3) },
              "before-upload": (file) => $setup.beforeUpload(file, 'delegationUrlHandleSuccess'),
              "on-remove": $setup.delegationUrlHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["data", "file-list", "on-preview", "on-success", "class", "before-upload", "on-remove", "accept", "action"])
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.userType === 1)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_el_upload, {
            data: { type: 20, courtId: $setup.courtId },
            "list-type": "picture-card",
            "on-success": $setup.mediationConfirmUrlHandleSuccess,
            "before-upload": (file) => $setup.beforeUpload(file, 'mediationConfirmUrlHandleSuccess'),
            accept: $setup.acceptImageUrl,
            limit: 5,
            class: { hide: $setup.isHide($setup.urlsList.mediationConfirmUrl, 5) },
            "on-preview": $setup.handlePictureCardPreview,
            "file-list": $setup.urlsList.mediationConfirmUrl,
            "on-remove": $setup.mediationConfirmUrlHandleRemove,
            action: $setup.getUrl + '/file/uploadConfirmAddressFile'
          }, {
            default: _withId(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["data", "on-success", "before-upload", "accept", "class", "on-preview", "file-list", "on-remove", "action"])
        ]))
      : _createCommentVNode("", true),
    ($props.userType === 2)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          _createVNode("div", null, [
            _hoisted_23,
            _createVNode(_component_SelectIdentityType, {
              type: "agent",
              onChangeIdentityType: $setup.changeAgentIdentityType
            }, null, 8, ["onChangeIdentityType"]),
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "list-type": "picture-card",
              "on-success": $setup.agentUserHandleSuccess,
              limit: $setup.agentIdentityType > 1 ? 3 : 1,
              "before-upload": (file) => $setup.beforeUpload(file, 'agentUserHandleSuccess'),
              "file-list": $setup.urlsList.agentUser,
              class: {
            hide: $setup.isHide($setup.urlsList.agentUser, $setup.agentIdentityType > 1 ? 3 : 1)
          },
              "on-preview": $setup.handlePictureCardPreview,
              "on-remove": $setup.agentUserHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["data", "on-success", "limit", "before-upload", "file-list", "class", "on-preview", "on-remove", "accept", "action"]),
            ($setup.agentIdentityType === 1)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  data: { type: 20, courtId: $setup.courtId },
                  "list-type": "picture-card",
                  limit: 1,
                  "on-success": $setup.agentUserBackHandleSuccess,
                  "file-list": $setup.urlsList.agentUserBack,
                  class: { hide: $setup.isHide($setup.urlsList.agentUserBack, 1) },
                  "on-preview": $setup.handlePictureCardPreview,
                  "before-upload": (file) => $setup.beforeUpload(file, 'agentUserBackHandleSuccess'),
                  "on-remove": $setup.agentUserBackHandleRemove,
                  style: {"margin-top":"10px"},
                  accept: $setup.acceptImageUrl,
                  action: $setup.getUrl + '/file/uploadConfirmAddressFile',
                  multiple: ""
                }, {
                  default: _withId(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["data", "on-success", "file-list", "class", "on-preview", "before-upload", "on-remove", "accept", "action"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_SelectIdentityType, {
              type: "proxy",
              onChangeIdentityType: $setup.changeProxyIdentityType
            }, null, 8, ["onChangeIdentityType"]),
            _createVNode(_component_el_upload, {
              "file-list": $setup.urlsList.agentProxy,
              data: { type: 20, courtId: $setup.courtId },
              limit: $setup.proxyIdentityType > 1 ? 3 : 1,
              class: {
            hide: $setup.isHide($setup.urlsList.agentProxy, $setup.proxyIdentityType > 1 ? 3 : 1)
          },
              "on-success": $setup.agentProxyHandleSuccess,
              "on-preview": $setup.handlePictureCardPreview,
              "before-upload": (file) => $setup.beforeUpload(file, 'agentProxyHandleSuccess'),
              "list-type": "picture-card",
              accept: $setup.acceptImageUrl,
              "on-remove": $setup.agentProxyHandleRemove,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_28
              ]),
              _: 1
            }, 8, ["file-list", "data", "limit", "class", "on-success", "on-preview", "before-upload", "accept", "on-remove", "action"]),
            ($setup.proxyIdentityType === 1)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  "file-list": $setup.urlsList.proxyIdentityPhotoBackUrl,
                  data: { type: 20, courtId: $setup.courtId },
                  limit: 1,
                  "on-success": $setup.agentProxyBackHandleSuccess,
                  class: { hide: $setup.isHide($setup.urlsList.proxyIdentityPhotoBackUrl, 1) },
                  style: {"margin-top":"10px"},
                  "on-preview": $setup.handlePictureCardPreview,
                  "before-upload": (file) => $setup.beforeUpload(file, 'agentProxyBackHandleSuccess'),
                  "list-type": "picture-card",
                  "on-remove": $setup.agentProxyBackHandleRemove,
                  accept: $setup.acceptImageUrl,
                  action: $setup.getUrl + '/file/uploadConfirmAddressFile',
                  multiple: ""
                }, {
                  default: _withId(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["file-list", "data", "on-success", "class", "on-preview", "before-upload", "on-remove", "accept", "action"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "list-type": "picture-card",
              "before-upload": (file) => $setup.beforeUpload(file, 'agentTrustHandleSuccess'),
              accept: $setup.acceptImageUrl,
              limit: 3,
              "on-success": $setup.agentTrustHandleSuccess,
              class: { hide: $setup.isHide($setup.urlsList.agentTrust, 3) },
              "on-preview": $setup.handlePictureCardPreview,
              "file-list": $setup.urlsList.agentTrust,
              "on-remove": $setup.agentTrustHandleRemove,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["data", "before-upload", "accept", "on-success", "class", "on-preview", "file-list", "on-remove", "action"])
          ]),
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_el_upload, {
              data: { type: 20, courtId: $setup.courtId },
              "file-list": $setup.urlsList.agentOther,
              "list-type": "picture-card",
              "on-success": $setup.agentOtherHandleSuccess,
              "on-preview": $setup.handlePictureCardPreview,
              "before-upload": (file) => $setup.beforeUpload(file, 'agentOtherHandleSuccess'),
              "on-remove": $setup.agentOtherHandleRemove,
              accept: $setup.acceptImageUrl,
              action: $setup.getUrl + '/file/uploadConfirmAddressFile',
              multiple: ""
            }, {
              default: _withId(() => [
                _hoisted_35
              ]),
              _: 1
            }, 8, ["data", "file-list", "on-success", "on-preview", "before-upload", "on-remove", "accept", "action"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: $setup.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.dialogVisible = $event)),
      width: "90%"
    }, {
      default: _withId(() => [
        _createVNode("img", {
          style: {"width":"90%"},
          src: $setup.dialogImageUrl,
          alt: ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_36, [
      _createVNode("button", {
        class: "btnSubmit",
        onClick: _cache[2] || (_cache[2] = (...args) => ($setup.userUploadFun(...args)))
      }, "下一步")
    ])
  ]))
})